<template>
	<div>
		<div class="bb-summary-table">
			<table class="uk-table">
                <caption class="sr-only">Order summary</caption>
                <thead>
                    <tr>
                        <th scope="col">Model</th>
                        <th scope="col">Sub-total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ wallbed.name }}</td>
                        <td>{{ totals.base | currency }}</td>
                    </tr>
                    <tr>
                        <th scope="row" colspan="2">Bed Size</th>
                    </tr>
                    <tr>
                        <td>{{ selected_size.mattress_size.name }}</td>
                        <td>-</td>
                    </tr>
                    <!--tr>
                        <td class="heading"><strong>Bed Type:</strong></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Side Mount</td>
                        <td>-</td>
                    </tr-->
                    <tr>
                        <th scope="row" colspan="2">Wood</th>
                    </tr>
                    <tr>
                        <td>{{ selected_wood.name }}</td>
                        <td>-</td>
                    </tr>
                    <tr>
                        <th scope="row" colspan="2">Finish</th>
                    </tr>
                    <tr>
                        <td>{{ selected_finish.name }}</td>
                        <td v-if="totals.finish_wallbed_upcharge == 0">-</td>
                        <td v-else> {{ totals.finish_wallbed_upcharge | currency }}</td>
                    </tr>
                    <tr>
                        <th scope="row" colspan="2">Options</th>
                    </tr>
                    <tr>
                        <td>{{ headboardSize }} Headboard</td>
                        <td>{{ headboardUpcharge }}</td>
                    </tr>
                    <tr v-if="selected_desk_table != null">
                        <td>{{ selected_desk_table.front_panel_type.name }}</td>
                        <td>{{ selected_desk_table.price | currency }}</td>
                    </tr>
                    <tr v-for="option in selected_options"
                        :key="option.id">
                        <td>{{ option.name }}</td>
                        <td>{{ option.wallbed_upcharge | currency }}</td>
                    </tr>
                    <!-- left cabinet -->
                    <tr>
                        <th scope="row" colspan="2">Left Cabinet</th>
                    </tr>
                    <tr v-if="selected_cabinet_left != null">
                        <td>{{ selected_cabinet_left.width | wholeNumber}}" {{ selected_cabinet_left.cabinet_type.name }}</td>
                        <td>{{ totals.left_cabinet | currency }}</td>
                    </tr>
                    <tr v-else>
                        <td>None</td>
                        <td>--</td>
                    </tr>
                    <tr v-if="left_cabinet_night_tray != false && selected_cabinet_left != null">
                        <td>Slide-out night tray</td>
                        <td>{{ wallbed.nightstand_upcharge | currency }}</td>
                    </tr>
                    <tr v-if="left_cabinet_glass_doors != false && selected_cabinet_left != null">
                        <td>Glass Doors</td>
                        <td>{{ wallbed.glass_door_upcharge | currency }}</td>
                    </tr>
                    <tr v-if="left_cabinet_glass_shelves != false && selected_cabinet_left != null">
                        <td>Glass Shelves</td>
                        <td>{{ wallbed.glass_shelf_upcharge | currency }}</td>
                    </tr>
                    <!-- right cabinet -->
                    <tr>
                        <th scope="row" colspan="2">Right Cabinet</th>
                    </tr>
                    <tr v-if="selected_cabinet_right != null">
                        <td>{{ selected_cabinet_right.width | wholeNumber}}" {{ selected_cabinet_right.cabinet_type.name }}</td>
                        <td>{{ totals.right_cabinet | currency }}</td>
                    </tr>
                    <tr v-else>
                        <td>None</td>
                        <td>--</td>
                    </tr>
                    <tr v-if="right_cabinet_night_tray != false && selected_cabinet_right != null">
                        <td>Slide-out night tray</td>
                        <td>{{ wallbed.nightstand_upcharge | currency }}</td>
                    </tr>
                    <tr v-if="right_cabinet_glass_doors != false && selected_cabinet_right != null">
                        <td>Glass Doors</td>
                        <td>{{ wallbed.glass_door_upcharge | currency }}</td>
                    </tr>
                    <tr v-if="right_cabinet_glass_shelves != false && selected_cabinet_right != null">
                        <td>Glass Shelves</td>
                        <td>{{ wallbed.glass_shelf_upcharge | currency }}</td>
                    </tr>
                    <tr>
                        <th scope="row" colspan="2">Mattress</th>
                    </tr>
                    <tr v-if="selected_mattress != null">
                        <td>{{ selected_mattress.name }}</td>
                        <td>{{ totals.mattress | currency }}</td>
                    </tr>
                    <tr v-else>
                        <td>None</td>
                        <td>--</td>
                    </tr>
                </tbody>
            </table>
            <table class="uk-table sub-totals">
                <tr>
                    <td>Shipping:</td>
                    <td>TBD</td>
                </tr>
                <tr>
                    <td>Tax:</td>
                    <td>TBD</td>
                </tr>
            </table>
            <p class="total" aria-live="polite" aria-atomic="true">Total: {{ totals.total | currency }}</p>
		</div>
	</div>
</template>

<script>
    import {mapState} from 'vuex';
	export default {
		name : "summary-table",
		components: {
        },
        computed : {
            headboardSize(){
                if(this.selected_headboard == null) return "";
                return this.selected_headboard.name;
            },
            /**
             * how much is the user paying for the headboard
             * @return {[type]} [description]
             */
            headboardUpcharge(){
                let price = 0;
                if(this.selected_headboard != null){
                    price = parseFloat(this.selected_headboard.price);
                }
                return (price > 0)? this.$options.filters.currency(price) : "-";
            },
            ...mapState({
                wallbed : state => state.wallbed,
                selected_size : state => state.selected_size,
                selected_wood : state => state.selected_wood,
                selected_finish : state => state.selected_finish,
                selected_headboard : state => state.selected_headboard,
                selected_desk_table : state => state.selected_desk_table,
                selected_options : state => state.selected_options,
                selected_cabinet_left : state => state.selected_cabinet_left,
                selected_cabinet_right : state => state.selected_cabinet_right,
                selected_mattress : state => state.selected_mattress,
                totals : state => state.totals,
                right_cabinet_night_tray : state => state.right_cabinet_night_tray,
                right_cabinet_glass_doors : state => state.right_cabinet_glass_doors,
                right_cabinet_glass_shelves : state => state.right_cabinet_glass_shelves,
                left_cabinet_night_tray : state => state.left_cabinet_night_tray,
                left_cabinet_glass_doors : state => state.left_cabinet_glass_doors,
                left_cabinet_glass_shelves : state => state.left_cabinet_glass_shelves,
            })
        }
	}
</script>